import { get, writable, derived, readable } from "svelte/store";

export const windowW = writable(0);
export const windowH = writable(0);

export const containerW = writable(0);
export const containerH = writable(0)
export const container = writable(null);

export const containerBBox = derived([windowW, windowH, container, containerW, containerH], ([$windowW, $windowH, $container, $containerW, $containerH]) => {
    return $container ? $container.getBoundingClientRect() : null;
})